import React from 'react'

import Box from 'components_new/atoms/Box'
import TextField from 'components_new/atoms/TextField'

interface NameStepProps {
  duplicate: boolean
  onChange: (name: string) => void
  value: string
}

const NameStep = (props: NameStepProps) => {
  const { duplicate, onChange, value } = props

  return (
    <Box sx={{ maxWidth: 480 }}>
      <TextField
        autoFocus={true}
        error={duplicate}
        fullWidth={true}
        helperText={
          duplicate ? 'Det finns redan en datakälla med det namnet' : undefined
        }
        label="Namn"
        onChange={(event) => onChange(event.target.value)}
        required={true}
        value={value}
      />
    </Box>
  )
}

export default NameStep
